import { CombinedGraphQLErrors } from "@apollo/client/errors";

// Codes mirror scribenote-backend's BE-2941 deleteOrgUser mutation; the
// rules live there only, this just maps them to copy.
const DELETE_ORG_USER_ERROR_MESSAGES: Record<string, string> = {
  SELF_DELETE: "You can't delete your own account.",
  LAST_ORG_ADMIN:
    "This user is the last admin of your organization. Make someone else an organization admin before deleting them.",
  USER_OUTSIDE_ORG:
    "This user is on teams outside your organization, so they can't be deleted here. Please contact Scribenote support for help.",
  NOT_ALLOWED:
    "You don't have permission to delete users in this organization.",
};

/** User-facing message for a failed deleteOrgUser call. */
export function getDeleteOrgUserErrorMessage(error: unknown): string {
  if (CombinedGraphQLErrors.is(error)) {
    for (const err of error.errors) {
      const code = err.extensions?.code;
      if (
        typeof code === "string" &&
        DELETE_ORG_USER_ERROR_MESSAGES[code]
      ) {
        return DELETE_ORG_USER_ERROR_MESSAGES[code];
      }
    }
  }
  const message =
    error instanceof Error ? error.message : String(error);
  return `Error deleting user: ${message}`;
}
